export const response = {
  "status": 200,
  "statistics": {
      "numPacientsEnrolats": [
          {
              "date": "2021-10",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 2,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2021-11",
              "ICHOMLPC": 1,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 0,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2021-12",
              "ICHOMLPC": 3,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 0,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-01",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 0,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-02",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-03",
              "ICHOMLPC": 1,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 0,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-04",
              "ICHOMLPC": 1,
              "ICHOMCAT_LEFT": 1,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-05",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 0,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-06",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 1,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-07",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 0,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-08",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 1,
              "ICHOMCAT_RIGHT": 0,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-09",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 1,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-10",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 0,
              "ICHOMPREG": 2,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-11",
              "ICHOMLPC": 2,
              "ICHOMCAT_LEFT": 5,
              "ICHOMCAT_RIGHT": 5,
              "ICHOMPREG": 57,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-12",
              "ICHOMLPC": 7,
              "ICHOMCAT_LEFT": 4,
              "ICHOMCAT_RIGHT": 3,
              "ICHOMPREG": 39,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-01",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 2,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 45,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-02",
              "ICHOMLPC": 2,
              "ICHOMCAT_LEFT": 4,
              "ICHOMCAT_RIGHT": 4,
              "ICHOMPREG": 41,
              "ICHOMPSYC": 3,
              "ICHOMMACDEG": 0,
              "MULSCLER": 1,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-03",
              "ICHOMLPC": 7,
              "ICHOMCAT_LEFT": 7,
              "ICHOMCAT_RIGHT": 7,
              "ICHOMPREG": 61,
              "ICHOMPSYC": 6,
              "ICHOMMACDEG": 0,
              "MULSCLER": 26,
              "ICHOMOLDER": 2,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-04",
              "ICHOMLPC": 4,
              "ICHOMCAT_LEFT": 8,
              "ICHOMCAT_RIGHT": 9,
              "ICHOMPREG": 44,
              "ICHOMPSYC": 3,
              "ICHOMMACDEG": 0,
              "MULSCLER": 35,
              "ICHOMOLDER": 5,
              "ICHOMSTROKE": 14,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-05",
              "ICHOMLPC": 7,
              "ICHOMCAT_LEFT": 7,
              "ICHOMCAT_RIGHT": 6,
              "ICHOMPREG": 39,
              "ICHOMPSYC": 9,
              "ICHOMMACDEG": 0,
              "MULSCLER": 66,
              "ICHOMOLDER": 1,
              "ICHOMSTROKE": 23,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-06",
              "ICHOMLPC": 2,
              "ICHOMCAT_LEFT": 19,
              "ICHOMCAT_RIGHT": 21,
              "ICHOMPREG": 37,
              "ICHOMPSYC": 4,
              "ICHOMMACDEG": 0,
              "MULSCLER": 43,
              "ICHOMOLDER": 2,
              "ICHOMSTROKE": 19,
              "ICHOMLUNGCANCER": 2,
              "ICHOMLIP": 2,
              "ICHOMLBP": 4,
              "ICHOMHF": 3,
              "ICHOMHVD": 1
          },
          {
              "date": "2023-07",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 3,
              "ICHOMCAT_RIGHT": 7,
              "ICHOMPREG": 18,
              "ICHOMPSYC": 2,
              "ICHOMMACDEG": 0,
              "MULSCLER": 15,
              "ICHOMOLDER": 1,
              "ICHOMSTROKE": 10,
              "ICHOMLUNGCANCER": 1,
              "ICHOMLIP": 2,
              "ICHOMLBP": 3,
              "ICHOMHF": 4,
              "ICHOMHVD": 1
          }
      ],
      "numPacientsActius": [
          {
              "date": "2021-10",
              "ICHOMLPC": 0,
              "ICHOMCAT_LEFT": 2,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2021-11",
              "ICHOMLPC": 1,
              "ICHOMCAT_LEFT": 2,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2021-12",
              "ICHOMLPC": 4,
              "ICHOMCAT_LEFT": 2,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-01",
              "ICHOMLPC": 3,
              "ICHOMCAT_LEFT": 2,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-02",
              "ICHOMLPC": 3,
              "ICHOMCAT_LEFT": 2,
              "ICHOMCAT_RIGHT": 2,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-03",
              "ICHOMLPC": 4,
              "ICHOMCAT_LEFT": 2,
              "ICHOMCAT_RIGHT": 2,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-04",
              "ICHOMLPC": 5,
              "ICHOMCAT_LEFT": 3,
              "ICHOMCAT_RIGHT": 2,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-05",
              "ICHOMLPC": 5,
              "ICHOMCAT_LEFT": 2,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-06",
              "ICHOMLPC": 5,
              "ICHOMCAT_LEFT": 2,
              "ICHOMCAT_RIGHT": 2,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-07",
              "ICHOMLPC": 5,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 2,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-08",
              "ICHOMLPC": 5,
              "ICHOMCAT_LEFT": 1,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-09",
              "ICHOMLPC": 5,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 0,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-10",
              "ICHOMLPC": 4,
              "ICHOMCAT_LEFT": 0,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 1,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-11",
              "ICHOMLPC": 6,
              "ICHOMCAT_LEFT": 4,
              "ICHOMCAT_RIGHT": 4,
              "ICHOMPREG": 58,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2022-12",
              "ICHOMLPC": 12,
              "ICHOMCAT_LEFT": 5,
              "ICHOMCAT_RIGHT": 4,
              "ICHOMPREG": 97,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-01",
              "ICHOMLPC": 5,
              "ICHOMCAT_LEFT": 4,
              "ICHOMCAT_RIGHT": 1,
              "ICHOMPREG": 142,
              "ICHOMPSYC": 0,
              "ICHOMMACDEG": 0,
              "MULSCLER": 0,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-02",
              "ICHOMLPC": 7,
              "ICHOMCAT_LEFT": 6,
              "ICHOMCAT_RIGHT": 4,
              "ICHOMPREG": 183,
              "ICHOMPSYC": 3,
              "ICHOMMACDEG": 0,
              "MULSCLER": 1,
              "ICHOMOLDER": 0,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-03",
              "ICHOMLPC": 12,
              "ICHOMCAT_LEFT": 9,
              "ICHOMCAT_RIGHT": 9,
              "ICHOMPREG": 243,
              "ICHOMPSYC": 9,
              "ICHOMMACDEG": 0,
              "MULSCLER": 27,
              "ICHOMOLDER": 2,
              "ICHOMSTROKE": 0,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-04",
              "ICHOMLPC": 11,
              "ICHOMCAT_LEFT": 13,
              "ICHOMCAT_RIGHT": 14,
              "ICHOMPREG": 275,
              "ICHOMPSYC": 11,
              "ICHOMMACDEG": 0,
              "MULSCLER": 62,
              "ICHOMOLDER": 7,
              "ICHOMSTROKE": 14,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-05",
              "ICHOMLPC": 14,
              "ICHOMCAT_LEFT": 14,
              "ICHOMCAT_RIGHT": 13,
              "ICHOMPREG": 301,
              "ICHOMPSYC": 20,
              "ICHOMMACDEG": 0,
              "MULSCLER": 128,
              "ICHOMOLDER": 7,
              "ICHOMSTROKE": 34,
              "ICHOMLUNGCANCER": 0,
              "ICHOMLIP": 0,
              "ICHOMLBP": 0,
              "ICHOMHF": 0,
              "ICHOMHVD": 0
          },
          {
              "date": "2023-06",
              "ICHOMLPC": 8,
              "ICHOMCAT_LEFT": 25,
              "ICHOMCAT_RIGHT": 26,
              "ICHOMPREG": 303,
              "ICHOMPSYC": 24,
              "ICHOMMACDEG": 0,
              "MULSCLER": 170,
              "ICHOMOLDER": 9,
              "ICHOMSTROKE": 50,
              "ICHOMLUNGCANCER": 2,
              "ICHOMLIP": 2,
              "ICHOMLBP": 4,
              "ICHOMHF": 3,
              "ICHOMHVD": 1
          },
          {
              "date": "2023-07",
              "ICHOMLPC": 7,
              "ICHOMCAT_LEFT": 8,
              "ICHOMCAT_RIGHT": 12,
              "ICHOMPREG": 281,
              "ICHOMPSYC": 26,
              "ICHOMMACDEG": 0,
              "MULSCLER": 185,
              "ICHOMOLDER": 10,
              "ICHOMSTROKE": 59,
              "ICHOMLUNGCANCER": 2,
              "ICHOMLIP": 4,
              "ICHOMLBP": 5,
              "ICHOMHF": 6,
              "ICHOMHVD": 1
          }
      ]
  }
}
